var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-btn", on: { click: _vm.openRecordPage } },
    [
      _c("img", {
        attrs: { src: require("@/assets/img/icon/record.png"), alt: "" },
      }),
      _c("span", [_vm._v(_vm._s(_vm.$ln("記錄")))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }